import React from "react";
import CajaGenerica from "./CajaGenerica";
import CajaVacia from "./CajaVacia";
import CajaTextoRosa from "./CajaTextoRosa";
import CajaTemporarios from "./CajaTemporario";

import CajaSimple from "./CajaSimple";

import dataSlider from "../datos/dataSilder";


export default function Expediciones() {
    let logoBalcon = "Logo-Balcon-de-Pissis"

    return (

            <div className="contenedor-principal">
                <section id={"aventura-en-seismiles"}>
                    <CajaVacia
                        encabezado={"Rutas que te llevan más alto"}
                        titulo={"Nuestras Expediciones"}
                        descripcion={
                           "Grupos reducidos de hasta 3 personas para máxima atención"
                        }
                        boton={""}
                    />
                    <div className="contenedor-imagenes"></div>
                </section>



                {dataSlider.map((obj, index) => {
                        return (

                    <CajaTemporarios
                        titulo={obj.titulo}
                        subtitulo={obj.subtitulo}
                        capacidad={obj.capacidad}
                        testimonios={obj.testimonios}
                        ubicacion={obj.ubicacion}
                        precio={obj.precio}
                        carpeta={obj.carpeta}

                    />

                        )
                    }
                )
                }


                <CajaGenerica
                    icon={"argentina.png"}

                    titulo={"Turismo en la Provincia de Catamarca"}
                    texto={"Conocé los lugares más lindos de la provincia de Catamarca. Te ofrecemos una guía de turismo para que puedas disfrutar de tus vacaciones."}
                />
                <CajaGenerica
                    icon={"argentina.png"}
                    titulo={"Turismo en la Provincia de La Rioja"}
                    texto={"Conocé los lugares más lindos de la La Rioja. Te ofrecemos una guía de turismo para que puedas disfrutar de tus vacaciones."}
                />
                <CajaGenerica
                    icon={"chile.png"}
                    titulo={"Turismo en Atacama - Chile"}
                    texto={"Conocé los lugares más lindos de la Región de Atacama, Chile . Te ofrecemos una guía de turismo para que puedas disfrutar de tus vacaciones."}
                />

            </div>

    );
}